'use es6';

import { combineReducers } from 'redux';
import Auth from './Auth';
import GettingStarted from './GettingStarted';
import Accounts from './Accounts';
export default combineReducers({
  accounts: Accounts,
  auth: Auth,
  gettingStarted: GettingStarted
});